import React from 'react';
import { Button, Grid, Typography, Box, TextField, Stack } from '@material-ui/core';
import { doctorReviewRequest } from 'src/services/doctor.service';
import ConfirmationDialogue from '../ConfirmationDialogue';

const successMessages = {
  APPROVED: 'Request Approved Successfully!',
  OPEN: 'Information Requested Successfully!',
  DISAPPROVED: 'Request Disapproved Successfully!'
};
const confirmationMessages = {
  APPROVED: 'Are you sure you want to approve this request?',
  OPEN: 'Are you sure you want to request more information?',
  DISAPPROVED: 'Are you sure you want to disapprove this request?'
};
const commentValidationError = {
  OPEN: 'Comments are required for requesting more information!',
  DISAPPROVED: 'Please provide disapproval reasons in the comments!'
};
function DoctorReview({ id, originalComments }) {
  const [comment, setComment] = React.useState(originalComments ?? '');
  const [newStatus, setNewStatus] = React.useState('');
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [commentsError, setCommentsError] = React.useState(false);
  const [commentsErrorMessage, setCommentsErrorMessage] = React.useState('');
  const handleClick = (status) => {
    if ((!comment || comment == '') && status !== 'APPROVED') {
      setCommentsError(true);
      setCommentsErrorMessage(commentValidationError[status]);
      return;
    }
    setNewStatus(status);
    setShowConfirmation(true);
  };
  return (
    <>
      <Grid
        direction="column"
        style={{
          marginTop: '20px',
          overflow: 'hidden',
          borderRadius: '10px',
          padding: '10px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
        }}
      >
        <Typography variant="h4">Doctor Review</Typography>{' '}
        <Box sx={{ width: '100%' }}>
          <TextField
            id="standard-textarea"
            error={commentsError}
            helperText={commentsError ? commentsErrorMessage : ''}
            label="Doctor Comments*"
            placeholder="Write any comments (Eg. extra required documents, etc.)"
            multiline
            style={{ width: '100%' }}
            variant="standard"
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              setCommentsError(false);
              setCommentsErrorMessage('');
            }}
          />
        </Box>
        <Stack fullwidth direction={'row'} gap={2} justifyContent={'flex-end'} marginTop={1}>
          <Button
            color="incorta"
            variant="contained"
            onClick={() => handleClick('APPROVED')}
            size="medium"
          >
            Approve
          </Button>
          <Button color="primary" variant="contained" onClick={() => handleClick('OPEN')}>
            Request more information
          </Button>
          <Button color="error" variant="contained" onClick={() => handleClick('DISAPPROVED')}>
            Disapprove
          </Button>
        </Stack>
      </Grid>
      <ConfirmationDialogue
        open={showConfirmation}
        setOpen={setShowConfirmation}
        redirectUrl={'/dashboard/all-requests'}
        confirmationMessage={confirmationMessages[newStatus]}
        loadingMessage={' Your review is being processed! Please do not close or refresh the page.'}
        queryId={['request', id]}
        successMessage={successMessages[newStatus]}
        onConfirm={() => doctorReviewRequest({ id: id, comment: comment, status: newStatus })}
      />
    </>
  );
}

export default DoctorReview;
